/* global FontFaceObserver */

import 'script-loader!fontfaceobserver';
import Cookies from 'js-cookie';

export default function({
    fonts         = [],
    bodyClass     = 'fonts-loaded',
    cookieName    = 'fonts-loaded',
    cookieExpires = 14, // days
    callback      = function() {}
} = {}) {

    // build up the wanted font observers
    fonts = fonts.map(font => {
        if (font) { // adding an empty ('') font crashes Browsers
            return (new FontFaceObserver(font, {})).load();
        }
    });

    function onPromiseDone(errorReason) {
        // set the class on the body
        document.documentElement.classList.add(bodyClass);

        // set the wanted cookie expiration date
        Cookies.set(cookieName, true, {expires: cookieExpires});

        // call the callback
        callback(errorReason);
    }

    // when all fonts are loaded
    Promise
        .all(fonts)
        .then(onPromiseDone)
        .catch(onPromiseDone); // android and safari fail to use the fontFaceLoader correctly -> set as if it succeeded for not breaking the UI and a still acceptable UX
}
